import {useMemo, useState} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import usePageMeta from '../../services/page-meta';
import './publicLanding.scss';

const LANDING_CONTENT = {
    uk: {
        intro: {
            title: 'Торкніться знань',
            lines: [
                'Безперервний професійний розвиток.',
                'Виключно для лікарів.',
                'Швидке навчання за фахом, яке завжди поруч.',
                'Долучайтеся!',
            ],
            cta: 'Зареєструватися',
        },
        upgrade: {
            title: 'Вдосконалюйте свою компетентність всього за 15 хвилин на день',
            instructionCta: 'переглянути інструкцію користувача',
            subtitle: 'Обирайте навчальні курси, важливі для Вашої практики',
            items: [
                {iconClass: 'doit_i3', lead: 'Станьте', text: 'обраним лікарем'},
                {iconClass: 'doit_i2', lead: 'Підвищуйте', text: 'власний професійний рівень безперервно'},
                {iconClass: 'doit_i1', lead: 'Навчайтеся', text: 'легко'},
                {iconClass: 'doit_i4', lead: 'Виконуйте', text: 'щоденні завдання'},
                {iconClass: 'doit_i5', lead: 'Беріть участь', text: 'в опитуваннях'},
            ],
        },
        who: {
            title: 'Хто ми',
            text: 'Аксемедін — Accelerator of Medical Information (Акселератор Медичної Інформації) — це освітня онлайн-платформа, яку створено виключно для професіоналів сфери охорони здоров’я. Метою Аксемедіна є якісне, безперервне вдосконалення професіоналізму лікаря в Україні. Навчання в Аксемедіні проходить за інтерактивною схемою, яка сприяє легшому засвоєнню інформації та сповільнює процес її забування. Міжнародна освітня модель спеціально адаптована для потреб сучасної спільноти лікарів України.',
        },
        joinCourses: {
            title: 'Долучайтеся до професійних навчальних курсів',
            items: [
                'Вивчайте те, що необхідно Вам',
                'Беріть участь в опитуваннях та висловлюйте власну точку зору — вона важлива для спільноти',
                'Підтримуйте власний високий рівень знань шляхом щоденного тестування',
            ],
        },
        aboutStudying: {
            title: 'Економія часу та ефективне навчання',
            items: [
                {iconClass: 'ecn_i1', lead: 'Дивіться', text: 'інформативні відеолекції'},
                {iconClass: 'ecn_i2', lead: 'Читайте', text: 'цікавий контент'},
                {iconClass: 'ecn_i3', lead: 'Досліджуйте', text: 'в експертних опитуваннях'},
                {iconClass: 'ecn_i4', lead: 'Вивчайте', text: 'корисні матеріали'},
                {iconClass: 'ecn_i5', lead: 'Грайте', text: 'з накопиченням балів'},
                {iconClass: 'ecn_i6', lead: 'Змагайтеся', text: 'для підвищення\nрейтингу'},
            ],
        },
        access: {
            title: 'Обирайте особистий рівень доступу до системи знань:',
            packages: [
                {
                    name: 'Стартовий',
                    iconClass: 'lvl_i1',
                    imageClass: 'lvl_im1',
                    points: ['Доступ до стартової навчальної бази знань та участь в опитуваннях'],
                    actionLabel: 'Обрати',
                    chooseAction: true,
                },
                {
                    name: 'Мотиваційний',
                    iconClass: 'lvl_i2',
                    imageClass: 'lvl_im2',
                    points: [
                        'Доступ до навчальної бази знань та участь в опитуваннях',
                        'Юридична допомога (для членів професійних спільнот)',
                        'Медичні довідники',
                        'Фармаконагляд (соціальний)',
                        'Участь у Реєстрі ТОП-100 у медицині (регіональний рівень)',
                    ],
                    actionLabel: 'Пакет активується після проходження рівня Стартовий',
                },
                {
                    name: 'Преміум',
                    iconClass: 'lvl_i3',
                    imageClass: 'lvl_im3',
                    points: [
                        'Доступ до навчальної бази та участь у різноманітних опитуваннях',
                        'Юридична допомога',
                        'Медичні довідники',
                        'Фармаконагляд',
                        'Участь у Реєстрі ТОП-100 у медицині (національний рівень)',
                        'Доступ до навчальної бази МІСів',
                        'Доступ до навчальної бази «авторських курсів»',
                        'Доступ до «конференц-сервісу»',
                        'Створення базового професійного портфоліо',
                        'Медичні калькулятори',
                        'Ігри',
                        'Можливість обміну балів',
                    ],
                    actionLabel: 'Пакет активується після проходження рівня Мотиваційний',
                },
            ],
            modal: {
                text: 'Дякуємо за Ваш вибір! Щоб почати навчання з пакетом «Стартовий», зареєструйтеся',
                cta: 'Зареєструватися',
            },
        },
        learnWhenever: {
            title: 'Навчайтеся! Де б Ви не були, у зручний для Вас час',
            cta: 'Зареєструватися',
        },
        efficient: {
            title: 'Відмовтеся від прісних книжок і занудливих лекцій на користь активного самонавчання та безперервного професійного розвитку',
            intro: 'Аксемедін надає Вам можливість у будь-який час отримувати доступ до бази потрібної та актуальної інформації, безперервно підтримувати та вдосконалювати власні знання. Зручна система освітніх пазлів, на які поділені навчальні курси, відрахує лише 15 хвилин на день Вашого часу. Запам’ятовуйте більше корисної інформації завдяки інтерактивним освітнім програмам з елементами гри, що стимулюють до розвитку.',
            points: [
                'Отримуйте нові знання із задоволенням',
                'Запам’ятовуйте корисну інформацію просто',
                'Застосовуйте отримані навички',
                'Збирайте бали та отримуйте сертифікати',
            ],
            outro: 'Аксемедін допомагає лікарям легше отримувати необхідні знання задля кращого їх втілення у практику. Аксемедін надає професіоналам галузі охорони здоров’я всі необхідні освітні інструменти, а також приклади їх впровадження, разом із допоміжними довідниками та іншою важливою лікарю інформацією. Користувачі Аксемедіна можуть формувати додаткові навички та підтримувати їх у здоровому тонусі, зважаючи на обмеження часу та навантаженість складної праці українського лікаря.',
        },
        joinUs: {
            title: 'Навчайтеся з нами! Долучайтеся до кола найкращих лікарів! Не зволікайте!',
            cta: 'Зареєструватися',
        },
    },
    en: {
        intro: {
            title: 'Touch the knowledge',
            lines: [
                'Continuous Professional Development for doctors',
                'Always with you, always for you',
            ],
            cta: 'Join now!',
        },
        upgrade: {
            title: 'Stay current on the latest medical knowledge in just 15 minutes a day',
            items: [
                {iconClass: 'doit_i3', lead: 'Choose', text: 'certified CPD courses'},
                {iconClass: 'doit_i2', lead: 'Earn', text: 'credits and keep track of your progress'},
                {iconClass: 'doit_i1', lead: 'Find', text: 'answers to your clinical questions'},
                {iconClass: 'doit_i4', lead: 'Discuss', text: 'clinical cases with colleagues'},
                {iconClass: 'doit_i5', lead: 'Register', text: 'for upcoming professional events'},
            ],
        },
        who: {
            title: 'Who are we?',
            text: 'Accemedin - is an online educational platform for doctors. Our goal is helping you regularly improve your medical expertise while earning CPD credits. With Accemedin, you can learn interactively and effortlessly at any convenient time and pace for you.',
        },
        joinCourses: {
            title: 'Join professional courses from experts and opinion leaders',
            items: [
                'interactive and video-based content tailored to your needs',
                'continuous approach to studying',
                'progress tracking and goal setting for better results',
            ],
        },
        aboutStudying: {
            title: 'Study efficiently and save time',
            items: [
                {iconClass: 'ecn_i1', lead: 'Watch', text: 'webinars'},
                {iconClass: 'ecn_i2', lead: 'Access', text: 'the latest medical content'},
                {iconClass: 'ecn_i3', lead: 'Share', text: 'your expertise with peers'},
                {iconClass: 'ecn_i4', lead: 'Participate', text: 'in surveys'},
                {iconClass: 'ecn_i5', lead: 'Challenge', text: 'yourself with quizzes'},
                {iconClass: 'ecn_i6', lead: 'Earn', text: 'points and unlock\nrewards'},
            ],
        },
        access: {
            title: 'Unlock more benefits with a premium package',
            comparisonColumns: ['Accemedin', 'Accemedin Premium'],
            comparisonRows: [
                {label: 'Access to certified CPD courses', basic: true, premium: true},
                {label: 'Access to clinical guidelines', basic: false, premium: true},
                {label: 'Legal support (for members of associations)', basic: false, premium: true},
                {label: 'Access to medical calculators', basic: false, premium: true},
                {label: 'Games and rewards', basic: false, premium: true},
            ],
        },
        learnWhenever: {
            title: 'Accemedin - always with you, always for you',
            cta: 'Join now!',
        },
    },
};

function renderWithBreaks(value) {
    const lines = String(value || '').split('\n');

    return lines.map((line, index) => (
        <span key={`${line}-${index}`}>
            {index > 0 && <br />}
            {line}
        </span>
    ));
}

function getLocaleContent(locale) {
    if (locale === 'en') {
        return LANDING_CONTENT.en;
    }

    return LANDING_CONTENT.uk;
}

export default function PublicLanding() {
    const {i18n, t} = useTranslation();
    usePageMeta({
        title: t('meta.publicLanding.title', t('app.title')),
        description: t('meta.publicLanding.description', t('app.description')),
        keywords: t('meta.publicLanding.keywords', t('app.keywords')),
    });

    const locale = i18n.resolvedLanguage === 'en' ? 'en' : 'uk';
    const content = useMemo(() => getLocaleContent(locale), [locale]);
    const [isAccessModalOpen, setIsAccessModalOpen] = useState(false);

    const registrationPath = '/account/registration';
    const instructionUrl = '/instruction';

    const showEfficient = locale !== 'en';
    const showJoinUs = locale !== 'en';
    const showInstructionButton = locale !== 'en';
    const showAccessPackages = locale !== 'en';

    return (
        <div className="public-landing" id="web">
            <section id="intro" className="intro block relative" style={{backgroundImage: 'url(/img/bg_int.jpg)'}}>
                <div className="container">
                    <img src="/img/bg_wint_.png" className="int_bgd" alt="" />
                    <h1>{content.intro.title}</h1>
                    <div className="int_txt">
                        {content.intro.lines.map((line, index) => (
                            <span key={`intro-line-${index}`}>
                                {index > 0 && <br />}
                                {line}
                            </span>
                        ))}
                    </div>
                    <div className="align-left relative">
                        <Link to={registrationPath} className="abtn red">{content.intro.cta}</Link>
                    </div>
                </div>
            </section>

            <section id="doit" className="doit block relative">
                <div className="container">
                    <h2 className="align-center">{content.upgrade.title}</h2>
                    {showInstructionButton && (
                        <div className="instruction-btn-box">
                            <Link to={instructionUrl} className="btn">{content.upgrade.instructionCta}</Link>
                        </div>
                    )}
                    {!!content.upgrade.subtitle && <div className="doit_txt align-center">{content.upgrade.subtitle}</div>}
                    <ul className="block relative align-center">
                        {content.upgrade.items.map((item, index) => (
                            <li key={`upgrade-item-${index}`}>
                                <div className="doit_i">
                                    <img src={index < 3 ? `/img/krs_i${3 - index}.svg` : `/img/doit_i${index + 1}.svg`} className={item.iconClass} alt="" />
                                </div>
                                <span>{item.lead}</span> {item.text}
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            <section id="who" className="who block relative">
                <div className="container">
                    <h2 className="align-center">{content.who.title}</h2>
                    <div className="block relative who_txt">{content.who.text}</div>
                </div>
            </section>

            <section id="krs" className="krs block relative">
                <div className="container">
                    <div className="krs_col1 relative">
                        <h2 className="align-center hd_bl">{content.joinCourses.title}</h2>
                        <img src="/img/krs_pc.svg" className="krs_pc" alt={content.joinCourses.title} />
                        <div className="krs_bvideo">
                            <video className="krs_video" autoPlay loop muted playsInline>
                                <source src="/video/video1.mp4" type="video/mp4" />
                                <source src="/video/video1.ogg" type="video/ogg" />
                                <source src="/video/video1.webm" type="video/webm" />
                            </video>
                        </div>
                    </div>
                    <div className="krs_col2 relative">
                        <h2 className="align-left">{content.joinCourses.title}</h2>
                        <ul>
                            {content.joinCourses.items.map((item, index) => (
                                <li key={`join-courses-item-${index}`}>
                                    <div className="krs_i">
                                        <img src={`/img/krs_i${index + 1}.svg`} className={`krs_i${index + 1}`} alt="" />
                                    </div>
                                    {index === 0 && <br />}
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </section>

            <section id="ecn" className="ecn block relative" style={{backgroundImage: 'url(/img/bg_ecn.jpg)'}}>
                <div className="pattern"></div>
                <div className="container">
                    <h2 className="align-center">{content.aboutStudying.title}</h2>
                    <ul className="block relative align-center ecn_bl">
                        {content.aboutStudying.items.map((item, index) => (
                            <li key={`about-studying-item-${index}`}>
                                <div className="ecn_i"><img src={`/img/ecn_i${index + 1}.svg`} className={item.iconClass} alt="" /></div>
                                <span>{item.lead}</span> {renderWithBreaks(item.text)}
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            <section id="lvl" className="lvl block relative">
                <div className="container align-center">
                    <h2>{content.access.title}</h2>

                    {showAccessPackages && (
                        <>
                            {content.access.packages.map((pack, index) => (
                                <div className={`pk pk${index + 1} pricing-cont`} key={`package-${index}`}>
                                    <div className="lvl_nm fw700">{pack.name}</div>
                                    <div className={`lvl_i ${pack.iconClass}`}><img src={`/img/lvl_im${index + 1}.svg`} className={`lvl_im ${pack.imageClass}`} alt={pack.name} /></div>
                                    <ul className="pricing">
                                        {pack.points.map((point, pointIndex) => (
                                            <li key={`package-point-${index}-${pointIndex}`}>{point}</li>
                                        ))}
                                    </ul>
                                    <div className="align-center relative lvl_btn">
                                        {pack.chooseAction ? (
                                            <button type="button" className="abtn red" onClick={() => setIsAccessModalOpen(true)}>{pack.actionLabel}</button>
                                        ) : (
                                            pack.actionLabel
                                        )}
                                    </div>
                                </div>
                            ))}
                        </>
                    )}

                    {!showAccessPackages && (
                        <div className="premium-comparison">
                            <div className="premium-header">
                                <div className="premium-title-cell"></div>
                                <div className="premium-column-title">{content.access.comparisonColumns[0]}</div>
                                <div className="premium-column-title">{content.access.comparisonColumns[1]}</div>
                            </div>
                            {content.access.comparisonRows.map((row, index) => (
                                <div className={`premium-row ${index === content.access.comparisonRows.length - 1 ? 'last' : ''}`} key={`premium-row-${index}`}>
                                    <div className="premium-feature">{row.label}</div>
                                    <div className="premium-cell">
                                        {row.basic && <img src="/img/check_black.svg" alt="Included" />}
                                    </div>
                                    <div className="premium-cell">
                                        {row.premium && <img src="/img/check_black.svg" alt="Included" />}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>

            <section id="nch" className="nch block relative" style={{backgroundImage: 'url(/img/bg_nch.jpg)'}}>
                <div className="pattern"></div>
                <div className="container">
                    <h2 className="align-center">{content.learnWhenever.title}</h2>
                    <div className="block relative nch_bl">
                        <img src="/img/nch_pc.svg" className="nch_im1" alt="Accemedin" />
                        <img src="/img/nch_kid.png" className="nch_im2" alt="" />
                        <img src="/img/nch_ph.png" className="nch_im3" alt="Accemedin" />
                    </div>
                    <div className="align-center relative">
                        <Link to={registrationPath} className="abtn red">{content.learnWhenever.cta}</Link>
                    </div>
                </div>
            </section>

            {showEfficient && (
                <section id="upd" className="upd block relative">
                    <div className="container">
                        <h2 className="align-center pb20">{content.efficient.title}</h2>
                        <div className="up_bl block relative">
                            <div className="up_tbl1 pb20">{content.efficient.intro}</div>
                            <ul className="block relative">
                                {content.efficient.points.map((point, index) => (
                                    <li key={`efficient-point-${index}`}>
                                        <div className="isvg">
                                            <img src={`/img/imup${index + 1}.svg`} alt="" />
                                        </div>
                                        {point}
                                    </li>
                                ))}
                            </ul>
                            <div className="up_tbl2">{content.efficient.outro}</div>
                            <img src="/img/up_ph.png" className="up_ph" alt="Accemedin" />
                        </div>
                    </div>
                </section>
            )}

            {showJoinUs && (
                <section id="off" className="off block relative">
                    <div className="container">
                        <h2 className="align-center">{content.joinUs.title}</h2>
                        <div className="align-center">
                            <Link to={registrationPath} className="abtn">{content.joinUs.cta}</Link>
                        </div>
                    </div>
                </section>
            )}

            {showAccessPackages && isAccessModalOpen && (
                <div className="landing-overlay" role="dialog" aria-modal="true">
                    <div className="landing-popup">
                        <div className="align-right">
                            <button type="button" className="landing-popup-close" onClick={() => setIsAccessModalOpen(false)} aria-label="Close">×</button>
                        </div>
                        <div className="pp_txt align-center">{content.access.modal.text}</div>
                        <div className="align-center relative">
                            <Link to={registrationPath} className="abtn red">{content.access.modal.cta}</Link>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
